/**
 * Format a number as a currency
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('de-AT', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
